import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import { setDohvaceniCompanies } from '../../store/slice/CompaniesSlice';
import { companiesToCompaniesTable } from '../../common/utils/HelperFunction';
import { Companies } from '../../common/types/types';
import { CompaniesComponent } from '../../components/companies/CompaniesComponent';
import CompaniesService from '../../service/CompaniesService';
import { useEffect } from 'react';

export const CompaniesContainer = () => {
  const updateTable = useAppSelector((state) => state.companies.updateTable);
  const dispatch = useAppDispatch();
  const getCompanies = () => {
    CompaniesService.getCompanies().then((response) => {
      dispatch(setDohvaceniCompanies(companiesToCompaniesTable(response.data as Array<Companies>)));
    });
  };

  useEffect(() => {
    getCompanies();
  }, [updateTable]);

  return <CompaniesComponent />;
};
